import HeatmapApi from "../apis/heatmap";

export const state = () => ({
  token: "",
  url: "",
  name: "",
  event_type: "",
  device: "sp",
  os: "",
  scroll_data: {},
  click_data: [],
  attention_data: {},
  scroll_gradient_data: [],
  attention_gradient_data: [],
  show_scroll_heatmap: true,
  show_click_heatmap: true,
  show_attention_heatmap: true,
  show_resize_heatmap: false,
  date_from: "",
  date_to: "",
  date_for_select: [
    { k: "today", v: "本日" },
    { k: "yesterday", v: "昨日" },
    { k: "this_month", v: "今月" },
    { k: "last_month", v: "先月" },
  ],
  fv_withdraw_rate: "",
  final_arrival_rate: "",
  avg_staying_sec: "",
  median_staying_sec: "",
  event_count: 0,
  event_data: {
    pop_state: 0,
    click: 0,
    blur: 0,
    other: 0,
  },
  device_data: {},
  os_data: {},
  page_height: 0,
  preview_page_height: 0,
  page_width: 0,
  ctx_y: "",
  ctx_r: "",
  shared: false,
  selectedVisitType: "",
  heatmap_design_id: 0,
  simul_display: true,
  click_link_logs: [],
  show_click_link_logs_modal: false,
  click_link_logs_loading: false,
});

export const actions = {
  async fixPageHeight({ commit, state }) {
    commit("setPageHeight", state.preview_page_height);
    commit("setShowResizeHeatmap", false);
  },
  async getScroll({ commit, state }) {
    const { data } = await HeatmapApi.scroll({
      token: state.token,
      device: state.device,
      os: state.os,
      event_type: state.event_type,
      date_from: state.date_from,
      date_to: state.date_to,
      selected_visit_type: state.selectedVisitType,
    });
    commit("setScrollData", data.scroll);

    commit("setScrollGradientData", data.gradient);

    commit("setEventCount", data.event_count);
    commit("setFvWithdrawRate", data.fv_withdraw_rate);
    commit("setFinalArrivalRate", data.scroll[100]);
    commit("setAvgStayingSec", data.avg_staying_sec);
    commit("setMedianStayingSec", data.median_staying_sec);

    commit("setEventData", data.event);
    commit("setDeviceData", data.device);
    commit("setOsData", data.os);
  },
  async getClick({ commit, state }) {
    const { data } = await HeatmapApi.click({
      token: state.token,
      device: state.device,
      os: state.os,
      event_type: state.event_type,
      date_from: state.date_from,
      date_to: state.date_to,
      selected_visit_type: state.selectedVisitType,
    });
    commit("setClickData", data.click);
  },
  async getAttention({ commit, state }) {
    const { data } = await HeatmapApi.attention({
      token: state.token,
      device: state.device,
      os: state.os,
      event_type: state.event_type,
      date_from: state.date_from,
      date_to: state.date_to,
      selected_visit_type: state.selectedVisitType,
    });
    commit("setAttentionGradientData", data.gradient);
    commit("setAttentionData", data.attention);
  },
  async getClickLinkLogs({ commit, state }, { heatmap_id }) {
    commit("setClickLinkLogsLoading", true);
    try {
      const { data } = await HeatmapApi.clickLinkLogs({
        heatmap_id: heatmap_id,
        from: state.date_from.split(' ')[0],
        to: state.date_to.split(' ')[0],
      });
      commit("setClickLinkLogs", data);
    } finally {
      commit("setClickLinkLogsLoading", false);
    }
  },
  drawClick({ commit, state }, { x, y }) {
    state.ctx_y.beginPath();
    state.ctx_r.beginPath();

    state.ctx_y.fillStyle = "rgba(" + [216, 255, 0, 0.2] + ")";
    state.ctx_y.arc(x, y, 15, 0, Math.PI * 2);
    state.ctx_y.fill();

    state.ctx_r.fillStyle = "rgba(" + [255, 106, 0, 0.4] + ")";
    state.ctx_r.arc(x, y, 10, 0, Math.PI * 2);
    state.ctx_r.fill();
  },
  clearCanvas({ commit, state }) {
    //state.ctx_y.clearRect(0, 0, state.page_width, state.page_height);
    //state.ctx_r.clearRect(0, 0, state.page_width, state.page_height);
  },
};

export const mutations = {
  setToken(state, token) {
    state.token = token;
  },
  setUrl(state, url) {
    state.url = url;
  },
  setName(state, name) {
    state.name = name;
  },
  setEvent(state, v) {
    state.event_type = v;
  },
  setSelectedVisitType(state, v) {
    state.selectedVisitType = v;
  },
  setHeatmapDesignId(state, v) {
    state.heatmap_design_id = v;
  },
  setSimulDisplay(state, v) {
    state.simul_display = v;
    if (state.simul_display){
      state.show_attention_heatmap = true;
      state.show_scroll_heatmap = true;
      state.show_click_heatmap = true;
    }
  },
  setDevice(state, v) {
    state.device = v;
    if (v === "sp"){
      state.simul_display = true
      state.show_attention_heatmap = true;
      state.show_scroll_heatmap = true;
      state.show_click_heatmap = true;
    }
  },
  setOs(state, v) {
    state.os = v;
  },
  setDateFrom(state, v) {
    state.date_from = v;
  },
  setDateTo(state, v) {
    state.date_to = v;
  },
  setScrollData(state, data) {
    state.scroll_data = data;
  },
  setAttentionData(state, data) {
    state.attention_data = data;
  },
  setClickData(state, data) {
    state.click_data = data;
  },
  setScrollGradientData(state, data) {
    state.scroll_gradient_data = data;
  },
  setAttentionGradientData(state, data) {
    state.attention_gradient_data = data;
  },
  setShowScrollHeatmap(state, bool) {
    state.show_scroll_heatmap = bool;
  },
  setShowClickHeatmap(state, bool) {
    state.show_click_heatmap = bool;
  },
  setShowAttentionHeatmap(state, bool) {
    state.show_attention_heatmap = bool;
  },
  setShowResizeHeatmap(state, bool) {
    state.show_resize_heatmap = bool;
  },
  setFvWithdrawRate(state, v) {
    state.fv_withdraw_rate = v;
  },
  setFinalArrivalRate(state, v) {
    state.final_arrival_rate = v;
  },
  setAvgStayingSec(state, v) {
    state.avg_staying_sec = v;
  },
  setMedianStayingSec(state, v) {
    state.median_staying_sec = v;
  },
  setEventData(state, v) {
    state.event_data = v;
  },
  setDeviceData(state, v) {
    state.device_data = v;
  },
  setOsData(state, v) {
    state.os_data = v;
  },
  setEventCount(state, v) {
    state.event_count = v;
  },
  setPageHeight(state, v) {
    state.page_height = v;
    state.preview_page_height = v;
  },
  setPreviewPageHeight(state, v) {
    state.preview_page_height = v;
  },
  setPageWidth(state, v) {
    state.page_width = v;
  },
  setCtxY(state, v) {
    state.ctx_y = v;
  },
  setCtxR(state, v) {
    state.ctx_r = v;
  },
  updateHeatmapShared(state, shared) {
    state.shared = shared;
  },
  setHeatmapUrl(state, url) {
    state.url = url;
  },
  setHeatmapUrlToken(state, token) {
    state.token = token;
  },
  setClickLinkLogs(state, data) {
    state.click_link_logs = data;
  },
  setShowClickLinkLogsModal(state, show) {
    state.show_click_link_logs_modal = show;
  },
  setClickLinkLogsLoading(state, loading) {
    state.click_link_logs_loading = loading;
  },
};

export const getters = {
  gradient(state) {
    var keys = Object.keys(state.scroll_gradient_data);
    var last_key = keys[keys.length - 1];

    var grad;
    for (let key in state.scroll_gradient_data) {
      if (key == "0") {
        grad = "linear-gradient(" + state.scroll_gradient_data[key] + ", ";
      } else {
        if (key == last_key) {
          grad = grad + state.scroll_gradient_data[key];
        } else {
          grad = grad + state.scroll_gradient_data[key] + " " + key + "%, ";
        }
      }
    }
    return grad;
  },
  attention_gradient(state) {
    //console.log("state.attention_gradient_data", state.attention_gradient_data)
    var keys = Object.keys(state.attention_gradient_data);
    var last_key = keys[keys.length - 1];
    var grad;
    for (let key in state.attention_gradient_data) {
      if (key == 1) {
        grad = "linear-gradient(" + state.attention_gradient_data[key] + ", ";
      } else {
        if (key == last_key) {
          grad = grad + state.attention_gradient_data[key];
        } else {
          grad = grad + state.attention_gradient_data[key] + " " + key + "%, ";
        }
      }
    }
    return grad;
  },
  clicks: (state) => {
    var r = [];
    if (state.click_data != undefined) {
      state.click_data.forEach((data) => {
        r.push({
          x: parseInt(state.page_width * data.rate_x),
          y: parseInt(state.page_height * data.rate_y),
          value: data.count,
        });
      });
      return r;
    } else {
      return r;
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
